import { useCallback } from 'react';
import { useCountryCityShippingRateDeleteMutation } from 'api';
import { notification } from 'components';
import { ErrorMappingValueType } from 'typings';

export const useDeleteModal = (onDeleteModalClose: () => void) => {
  const [notificationApi, contextHolder] = notification.useNotification();
  const [countryCityShippingRateDelete, { isLoading }] = useCountryCityShippingRateDeleteMutation();

  const openNotificationWithIcon = useCallback(
    (messageContent: ErrorMappingValueType) => {
      const { type, message } = messageContent;
      notificationApi[type]({ message: message });
    },
    [notificationApi]
  );

  const onRemoveConfirm = useCallback(
    async (shipping: { id: string | undefined }) => {
      try {
        const { data, error }: any = await countryCityShippingRateDelete({
          id: shipping.id,
        });

        if (data?.success) {
          onDeleteModalClose();
          openNotificationWithIcon({
            type: 'success',
            message: `The City Shipping Rate was successfully deleted.`,
          });
        } else if (error?.data?.success === false) {
          const { data = {} } = error.data;
          Object.keys(data).forEach((_key: string) => {
            openNotificationWithIcon({
              type: 'error',
              message: data[_key],
            });
          });
        } else {
          openNotificationWithIcon({
            type: 'error',
            message: error?.data?.error || 'Something went wrong!',
          });
        }
      } catch (err) {
        console.error('Error deleting city shipping rate:', err);
        openNotificationWithIcon({
          type: 'error',
          message: 'An unexpected error occurred!',
        });
      }
    },
    [countryCityShippingRateDelete, openNotificationWithIcon, onDeleteModalClose]
  );

  return {
    onRemoveConfirm,
    contextHolder,
    isLoading,
  };
};
